import { useEffect, useState } from "react";
import styled from "styled-components";

const SizeFilterWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 991px) {
    display: flex;
    width: 100%;
  }
  @media (max-width: 767px) {
    display: none;
  }
`;

const MobileSizeFilterWrapper = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    width: 100%;
  }
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 300px;

  @media (max-width: 767px) {
    max-width: none;
  }
`;

const SizeInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 40px 0 12px;
  font-size: 14px;
  border: 1px solid #3bb77e;
  border-radius: 8px;
  outline: none;
`;

const SearchButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3bb77e;
  background: transparent;
  border: none;
  padding: 0;

  i {
    font-size: 16px;
  }
`;

const EsgSearchFilter = ({ searchParams, setSearchParams, onPageChange }) => {
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (searchParams?.searchTerm) {
      setSearchTerm(searchParams.searchTerm);
    } else {
      setSearchTerm("");
    }
  }, [searchParams]);

  const handleFilter = () => {
    setSearchParams((prev) => ({
      ...prev,
      searchTerm: searchTerm,
      page: 1,
    }));

    if (onPageChange) {
      onPageChange(1);
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleFilter();
    }
  };

  const renderSearchBox = () => (
    <InputWrapper>
      <SizeInput
        onChange={handleInputChange}
        placeholder="검색어를 입력하세요"
        value={searchTerm}
        onKeyDown={handleKeyDown}
        aria-label="검색어 입력"
      />
      <SearchButton onClick={handleFilter} aria-label="검색">
        <i className="fi-rs-search" aria-hidden="true" />
      </SearchButton>
    </InputWrapper>
  );

  return (
    <>
      <SizeFilterWrapper>{renderSearchBox()}</SizeFilterWrapper>
      <MobileSizeFilterWrapper>{renderSearchBox()}</MobileSizeFilterWrapper>
    </>
  );
};

export default EsgSearchFilter;
